module.exports = __webpack_public_path__ + "static/media/ic-arrow-more.75ea5c38.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/DualSelect/assets/ic-arrow-more.svg
// module id = 1063
// module chunks = 0